// extracted by mini-css-extract-plugin
module.exports = {"collectionButton":"CollectionButton_collectionButton__yJILv","isolated":"CollectionButton_isolated__8ZLkW","isActive":"CollectionButton_isActive__TXwaD"};